import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import '../../assets/css/carousel.css';
import {Link, Image} from '@shopify/hydrogen';
import {getPath} from '../../lib/methods';
import {useCallback} from 'react';
import {useState} from 'react';
import {useEffect} from 'react';
export default function GridCarousel({list}) {
  const [viewportRef, embla] = useEmblaCarousel({
    containScroll: 'scrollSnap',
    slidesToScroll: 1,
    inViewThreshold: 1,
    skipSnaps: false,
    selectedClass: '',
    dragFree: true,
    align: 'start',
    loop: false,
  });

  const [browserWidth, setBrowserWidth] = useState(0);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla, setSelectedIndex]);

  useEffect(()=>{
    const width = window.innerWidth;
    setBrowserWidth(width);
  },[])

  useEffect(() => {
    if (!embla) return;
    onSelect();
    setScrollSnaps(embla.scrollSnapList());
    embla.on('select', onSelect);
  }, [embla, setScrollSnaps, onSelect]);

  return (
    <div className="carousel_wrapper relative w-full">
      <div className="overflow-hidden w-full">
        <div ref={viewportRef}>
          <div className="flex">
            {list.map((item) => {
              return (
                <div
                  className={`
                    p-2 xs:p-0
                    ${
                      list.length == 3
                        ? 'md:w-4/12'
                        : list.length == 4
                        ? 'md:w-3/12'
                        : list.length >= 5
                        ? 'md:w-1/5 carousel-item-flex'
                        : 'md:w-1/5'
                    }
                  `}
                  key={item._key}
                >
                  <div className="grid_carousel__slide" key={item.key}>
                    <Link to={getPath(item)} reloadDocument="true"
                      alt={item.title}
                    >
                      <div className="rounded-lg relative overflow-hidden">
                        <h3 className="list-banner-title">{item.title}</h3>
                        <Image
                          src={
                            (browserWidth < 576)
                            ? item.image.asset.url+'?fm=webp&h=350&w=350'
                            : item.image.asset.url
                          }
                          height={227}
                          width={'100%'}
                          alt={`Carrousel ${item.title}`}
                          className="card card-image xs:h-full md:w-full"
                        />
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
        <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
      </div>
    </div>
  );
}

const PrevButton = ({enabled, onClick}) => (
  <button
    className={` ${
      !enabled ? 'disabled' : 'fill-purple-120'
    } btn-prev xs:hidden left-0 absolute bottom-46 flex items-center justify-center rounded-full h-10 w-10 bg-white cursor-pointer`}
    onClick={onClick}
    disabled={!enabled}
  >
    <svg
      className={` ${!enabled ? 'fill-white' : 'fill-purple-120'}
          embla__button__svg h-5 w-5  fill-purple-120
        `}
      viewBox="137.718 -1.001 366.563 644"
    >
      <path d="M428.36 12.5c16.67-16.67 43.76-16.67 60.42 0 16.67 16.67 16.67 43.76 0 60.42L241.7 320c148.25 148.24 230.61 230.6 247.08 247.08 16.67 16.66 16.67 43.75 0 60.42-16.67 16.66-43.76 16.67-60.42 0-27.72-27.71-249.45-249.37-277.16-277.08a42.308 42.308 0 0 1-12.48-30.34c0-11.1 4.1-22.05 12.48-30.42C206.63 234.23 400.64 40.21 428.36 12.5z" />
    </svg>
  </button>
);

const NextButton = ({enabled, onClick}) => {
  return (
    <button
      className={` ${
        !enabled ? 'disabled' : 'fill-purple-120'
      } btn-next xs:hidden absolute right-0 bottom-46 flex items-center justify-center rounded-full h-10 w-10 bg-white cursor-pointer`}
      onClick={onClick}
      disabled={!enabled}
    >
      <svg
        className={`embla__button__svg  h-5 w-5 fill-purple-120  ${
          !enabled ? 'fill-white' : 'fill-purple-120'
        }`}
        viewBox="0 0 238.003 238.003"
      >
        <path d="M181.776 107.719L78.705 4.648c-6.198-6.198-16.273-6.198-22.47 0s-6.198 16.273 0 22.47l91.883 91.883-91.883 91.883c-6.198 6.198-6.198 16.273 0 22.47s16.273 6.198 22.47 0l103.071-103.039a15.741 15.741 0 0 0 4.64-11.283c0-4.13-1.526-8.199-4.64-11.313z" />
      </svg>
    </button>
  );
};
